import React, { Component } from "react";
import firebase from '../Config/Firebase';

class SplitModeButtons extends Component {
  constructor(props) {
    super(props);
    this.selectSplitType = this.selectSplitType.bind(this);
  }
  selectSplitType(e) {
    if (e.target.value &&
      ((e.target.value === 'paybyitems') || (e.target.value === 'splitequally'))
    ) {
      this.setState({
        splitType: e.target.value
      });
      if (this.props.owner === this.props.loggedInUser) {
        return firebase.database().ref(`tables/${this.props.tableID}/`).update({
          splitType: e.target.value,
        });
      } else {
        return;
      }
    } else {
      alert("You've paid all")
      this.setState({
        splitType: ""
      });
      return firebase.database().ref(`tables/${this.props.tableID}/`).update({
        splitType: "",
      });
    }
  }
  render() {
    return (
      <div className="paymode-div">
      <h4>How would you like to pay?</h4>
        <button type="button" className="btn btn-block paymode-btn payall" value="payall" onClick={this.selectSplitType}>Pay All</button>
        <button type="button" className="btn btn-block paymode-btn splitequally" value="splitequally" onClick={this.selectSplitType}>Split Equally</button>
        <button type="button" className="btn btn-block paymode-btn paybyitems" value="paybyitems" onClick={this.selectSplitType}>Choose My Items</button>
      </div>
    )
  }
}

export default SplitModeButtons;


// WEBPACK FOOTER //
// ./src/Components/SplitModeButtons.js